import { EventEmitter } from "./eventEmitter";
function timeout(pay) {
    console.log("timeout", pay.timeout);
    if (pay._idTimeout) {
        clearTimeout(pay._idTimeout);
    }
    pay._idTimeout = setTimeout(async () => {
        if (pay._ws) {
            console.log("timeout");
            if (pay.currentPayment) {
                // TODO: transacao so pode ser cancelada quando não for selecionada na POS
                try {
                    await pay.method("cancel");
                }
                catch (e) { }
            }
            pay.disconnect();
            pay.evt.trigger("change", {
                name: "timeout",
                finish: true,
            });
        }
    }, pay.timeout);
}
export class ZettaPay {
    constructor() {
        this.url = "wss://pay.zettabrasil.com.br";
        this.token = null;
        this.currentPayment = null;
        this.evt = new EventEmitter();
        this.idMsg = 0;
        this.timeout = 120000;
        this._responses = new Map();
    }
    onChange(fn) {
        this.evt.on("change", fn);
    }
    async cobrar(provider, payment) {
        this.currentPayment = null;
        try {
            await this.connect();
            const resp = await this.method("create", provider, payment);
            this.currentPayment = resp;
            return resp;
        }
        catch (e) {
            this.disconnect();
            if (e.target instanceof WebSocket) {
                throw new Error("Não foi possível conectar no serviço de pagamentos");
            }
            throw new Error(e);
        }
    }
    async abortar() {
        // TODO: transacao so pode ser cancelada quando não for selecionada na POS
        await this.method("cancel");
        this.disconnect();
    }
    connect() {
        return new Promise((resolve, reject) => {
            if (this._ws) {
                this.disconnect();
            }
            const ws = new WebSocket(`${this.url}?t=${this.token}`);
            ws.onopen = () => {
                console.log("open");
                this._ws = ws;
                resolve();
                timeout(this);
            };
            ws.onclose = () => {
                console.log("close");
                if (this._ws) {
                    this._ws = null;
                    this.evt.trigger("change", {
                        name: "close",
                        finish: true,
                    });
                }
            };
            ws.onerror = (e) => {
                console.log("error", e);
                reject(e);
            };
            ws.onmessage = (e) => {
                if (typeof e.data === "string") {
                    const msg = JSON.parse(e.data);
                    if (msg.type === "ping") {
                        this._ws.send(JSON.stringify({ type: "pong" }));
                        return;
                    }
                    if (msg.type === "result") {
                        const respCallback = this._responses.get(msg.id);
                        this._responses.delete(msg.id);
                        msg.error
                            ? respCallback?.reject(msg.error)
                            : respCallback?.resolve(msg.result);
                        return;
                    }
                    if (msg.type === "event") {
                        console.log("event", msg);
                        if (msg.paymentChange) {
                            if ("processing" === msg.paymentChange.status) {
                                timeout(this);
                            }
                            const finish = ["finish", "deleted"].includes(msg.paymentChange.status);
                            if (finish) {
                                this.disconnect();
                            }
                            this.evt.trigger("change", {
                                name: "status",
                                finish,
                                data: msg.paymentChange,
                            });
                            return;
                        }
                        // TODO: para suportar versao antiga do zetta-pay
                        if (msg.preTransaction) {
                            if ("processing" === msg.preTransaction?.status) {
                                timeout(this);
                            }
                            const finish = ["processed", "undone"].includes(msg.preTransaction?.status);
                            if (finish) {
                                this.disconnect();
                            }
                            this.evt.trigger("change", {
                                name: "status",
                                finish,
                                data: msg.preTransaction,
                            });
                            return;
                        }
                    }
                }
            };
        });
    }
    disconnect() {
        this._ws?.close();
        this._responses.clear();
        this._ws = null;
    }
    send(msg) {
        if (!this._ws) {
            throw new Error("ws closed");
        }
        msg.id = this.idMsg++;
        this._ws.send(JSON.stringify(msg));
        return new Promise((resolve, reject) => {
            this._responses.set(msg.id, { resolve, reject });
        });
    }
    method(name, ...params) {
        return this.send({
            type: "method",
            method: name,
            params,
        });
    }
}
